import { ReactElement } from 'react';

import { ThemeEnum } from '../../../../../../../../../shared/theme/enums/theme.enum';
import sofdcarLogo from '../../../../../../../assets/icons/topbar-icon/sofdcar-logo.png';
import { ReactComponent as SparqLogo } from '../../../../../../../assets/icons/topbar-icon/sparqos-logo-Sparq.svg';

export const logoMap: Map<ThemeEnum, ReactElement> = new Map<
  ThemeEnum,
  ReactElement
>([
  [ThemeEnum.SPARQ, <SparqLogo title="SPARQ store Logo" />],
  [
    ThemeEnum.SOFDCAR,
    <img
      alt="Software Defined Car Logo"
      title="Software Defined Car Logo"
      src={sofdcarLogo}
    />,
  ],
]);
